module.exports = __webpack_public_path__ + "img/logo.b92a0ae.png";